module.exports = __webpack_public_path__ + "img/mail.5ebfc7cc.svg";